import Form from 'react-bootstrap/Form';
import React, { useState, useEffect } from 'react';
import { _eval } from "../utils";
import BaseField from './BaseField';

function SelectInput(props) {

    const [showError, setShowError] = useState(false);

    const handleChange = (v) => {

        // Check if we must map the field
        const map = (() => {
            if (_eval(props, 'data', 'map'))
                return props.data.map
            else
                return false
        })()

        // check if a value is selected
        // (and not the default placeholder value) 
        const requirePass = (() => {
            if (props.data.placeholder)
                return v === props.data.placeholder
            else return false
        })()
        setShowError(requirePass)

        // Rewrite the value if needed
        if (_eval(props.data.items[0], 'value')) {
            const _v = props.data.items.find(
                i => { return i.label === v }
            )
            if (_eval(_v), 'value') {
                v = _v.value
            }
        }

        // If we must keep the label in the value,
        // concat the label with the value
        if (_eval(props, 'data', 'keepLabel'))
            if (props.data.keepLabel === true)
                v = props.data.label + ' -> ' + v

        // send data to parent
        props.handleChange(props.data.sid, { value: v, validity: !requirePass, map: map })

    }

    return (
        <BaseField
            data={props.data}
            handleChange={props.handleChange}
            formData={props.formData}
        >
            <Form.Group>

                {props.data.label.length > 0 ?
                    <Form.Label htmlFor={`input-for-${props.data.sid}`}>
                        {props.data.label}
                        {props.data.required ?
                            <span className='text-danger'>&nbsp;*</span>
                            : null}
                    </Form.Label>
                    : null}

                <Form.Select
                    value={props.data.value}
                    onChange={e => { props.data.value = e.target.value; handleChange(e.target.value) }}
                    data-validity-selector={props.data.sid}
                >
                    <option className='text-muted'>
                        {props.data.placeholder}
                    </option>
                    {props.data.items.map((c, i) => {
                        let label = !_eval(c, 'label') ? c : c.label;
                        const value = label.constructor === Array ? label[0] : label;
                        label = label.constructor === Array ? label[1] : label;
                        if (c.groupLabel) {
                            return (
                                <option key={i} disabled={true} value="void" className='text-muted my-2'><i>— {c.groupLabel}</i></option>
                            )
                        } else {
                            return (
                                <option key={i}
                                    id={`select-option-for-${props.data.sid}-key-${i}`}
                                    label={label}
                                    disabled={c.disabled}
                                    value={value}
                                >
                                    {label}
                                </option>
                            )
                        }
                    })}
                </Form.Select>

                {props.data.helper ?
                    <Form.Text id={`helper-for-${props.data.sid}`} muted dangerouslySetInnerHTML={{ __html: props.data.helper }} />
                    : null}

                {/* Field live check */}
                {props.data.error && showError ?
                    <div>
                        <Form.Text id={`error-for-${props.data.sid}`} className='text-danger'>
                            {props.data.error}
                        </Form.Text>
                    </div>
                    : null}

                {/* Field check validity on submit */}
                {!(props.data.error && showError) ?
                    <Form.Control.Feedback type="invalid">
                        {props.data.error}
                    </Form.Control.Feedback>
                    : null}
            </Form.Group>

        </BaseField>
    );
}

export default SelectInput;